"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_s3_1 = require("@aws-sdk/client-s3");
const s3_request_presigner_1 = require("@aws-sdk/s3-request-presigner");
class S3 {
    constructor(paramsOverride) {
        this.s3Client = new client_s3_1.S3Client(paramsOverride || {});
    }
    async putJsonObject(bucket, key, body, paramsOverride) {
        const params = {
            Bucket: bucket,
            Key: key,
            Body: JSON.stringify(body),
            ContentType: 'application/json',
            ...paramsOverride
        };
        const command = new client_s3_1.PutObjectCommand(params);
        return this.s3Client.send(command);
    }
    async deleteObject(bucket, key) {
        const command = new client_s3_1.DeleteObjectCommand({ Bucket: bucket, Key: key });
        await this.s3Client.send(command);
    }
    async headObject(bucket, key) {
        const command = new client_s3_1.HeadObjectCommand({ Bucket: bucket, Key: key });
        return this.s3Client.send(command);
    }
    async hasKeyInBucket(bucket, key) {
        try {
            const metadata = await this.headObject(bucket, key);
            return metadata != null;
        }
        catch (ex) {
            console.log(ex);
            return false;
        }
    }
    async getAsJsonObject(bucket, key) {
        const command = new client_s3_1.GetObjectCommand({ Bucket: bucket, Key: key });
        const res = await this.s3Client.send(command);
        if (res.Body) {
            const dataStr = await res.Body.transformToString('utf-8');
            return JSON.parse(dataStr);
        }
        return {};
    }
    async getDownloadUrl(bucket, key, expiresIn = S3.urlExpiresIn, paramsOverride) {
        const params = {
            Bucket: bucket,
            Key: key,
            ...paramsOverride
        };
        const command = new client_s3_1.GetObjectCommand(params);
        return this.getSignedUrl(command, expiresIn);
    }
    async getUploadUrl(bucket, key, expiresIn = S3.urlExpiresIn, paramsOverride) {
        const params = {
            Bucket: bucket,
            Key: key,
            ...paramsOverride
        };
        const command = new client_s3_1.PutObjectCommand(params);
        return this.getSignedUrl(command, expiresIn);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
    async getSignedUrl(command, expiresIn) {
        return (0, s3_request_presigner_1.getSignedUrl)(this.s3Client, command, { expiresIn });
    }
    async getObject(bucket, key) {
        const command = new client_s3_1.GetObjectCommand({ Bucket: bucket, Key: key });
        return this.s3Client.send(command);
    }
    async upload(bucket, key, paramsOverride) {
        const params = {
            Bucket: bucket,
            Key: key,
            ...paramsOverride
        };
        const command = new client_s3_1.PutObjectCommand(params);
        return this.s3Client.send(command);
    }
    async listBucketObjects(bucket, prefix, delimiter) {
        let params = {
            Bucket: bucket,
            Prefix: prefix
        };
        if (delimiter)
            params = { ...params, Delimiter: delimiter };
        const command = new client_s3_1.ListObjectsCommand(params);
        return this.s3Client.send(command);
    }
    async copyObjectInBucket(bucket, sourceKey, destinationKey) {
        return this.copyObjectToAnotherBucket(bucket, sourceKey, bucket, destinationKey);
    }
    async copyObjectToAnotherBucket(sourceBucket, sourceKey, destinationBucket, destinationKey) {
        const input = {
            CopySource: `/${sourceBucket}/${sourceKey}`,
            Bucket: destinationBucket,
            Key: destinationKey
        };
        const command = new client_s3_1.CopyObjectCommand(input);
        return this.s3Client.send(command);
    }
    async getBucketCors(bucket) {
        const command = new client_s3_1.GetBucketCorsCommand({ Bucket: bucket });
        return this.s3Client.send(command);
    }
    async putObjectTagging(bucket, key, tags) {
        const command = new client_s3_1.PutObjectTaggingCommand({
            Bucket: bucket,
            Key: key,
            Tagging: { TagSet: tags }
        });
        await this.s3Client.send(command);
    }
}
exports.default = S3;
S3.urlExpiresIn = 60 * 30;
